var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPreview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "13px",
    viewBox: "0 0 19 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Preview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Invite-received_register",
    transform: "translate(-884.000000, -369.000000)",
    fill: "#6E6E6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(529.000000, 337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(353.000000, 26.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.95,6 C15.25,6 18.45,8 20.65,11.5 L20.65,11.5 L21.05,12.1 L20.65,12.6 C18.45,16 15.15,18 11.95,18 C8.65,18 5.25,15.8 3.25,12.5 L3.25,12.5 L2.95,12 L3.25,11.5 C5.15,8.1 8.45,6 11.95,6 Z M11.95,8 C9.35,8 6.85,9.5 5.25,12 C6.95,14.4 9.55,16 11.95,16 C14.35,16 16.85,14.5 18.65,12.1 C16.85,9.5 14.35,8 11.95,8 Z M11.95,9 C13.65,9 14.95,10.3 14.95,12 C14.95,13.7 13.65,15 11.95,15 C10.25,15 8.95,13.7 8.95,12 C8.95,10.3 10.25,9 11.95,9 Z M11.95,11 C11.35,11 10.95,11.4 10.95,12 C10.95,12.6 11.35,13 11.95,13 C12.55,13 12.95,12.6 12.95,12 C12.95,11.4 12.55,11 11.95,11 Z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Preview.17afc5e57425050eb229dea6a8fd781a.svg";